'use strict';

const SELECTORS = {
    giftOrderContainer         : '.js-gift-order-container',
    giftOrderMessageCounter    : '.js-gift-msg-character-count',
    giftOrderToggleableSection : '.js-gift-order-toggleable-section',
    giftOrderIsGiftOrderField  : '.js-gift-order-checkbox',
    giftOrderRecipientField    : '.js-giftRecipient',
    giftOrderSenderField       : '.js-giftSender',
    giftOrderMessageField      : '.js-gift-order-message',
};

const CONSTANTS = $(SELECTORS.giftOrderContainer).data('constants');

var GIFT_ORDER_FIELD_SELECTOR_LIST = [
    SELECTORS.giftOrderIsGiftOrderField,
    SELECTORS.giftOrderRecipientField,
    SELECTORS.giftOrderSenderField,
    SELECTORS.giftOrderMessageField
].join(', ');

const validateGiftOrderMessageInput = (input) => {
    var allowedCharactersRegex = new RegExp(/^[a-zA-Z0-9!@#$%^&*\\/|?<,>\.:;{\}\[\]'" ~)(+=._-]+$/g); // eslint-disable-line
    return allowedCharactersRegex.test(input);
}

function isGiftOrder() {
    return $('.js-gift-order-checkbox').is(':checked');
}

function setState(state) {
    $('.gift-message-container').attr('data-mode', state);
}

/**
* Updates the gift message summary section in the UI based on the current gift message state and input values.
* Sets the appropriate data-mode attribute for the gift message container, and populates the recipient, message, and sender summary fields
* with the values entered by the user.
*
* @returns {void}
*/
function fillGiftMessageSummary() {
    var GIFT_MESSAGE = $('.js-gift-order-container').data('constants');

    const nextGiftState = $('.js-gift-order-checkbox').is(':checked') ? 
        GIFT_MESSAGE.STATES.EDITABLE :
        GIFT_MESSAGE.STATES.NO_GIFT_MESSAGE;

    $('.gift-message-container').attr('data-mode', nextGiftState);

    $('.js-gift-recipient-summary').html($('.js-giftRecipient').val());
    $('.js-gift-message-summary').html($('.js-gift-order-message').val());
    $('.js-gift-sender-summary').html($('.js-giftSender').val());
}

module.exports = {
    init: function () {
        $(GIFT_ORDER_FIELD_SELECTOR_LIST).on('paste', function (e) {
            var pastedData = e.originalEvent.clipboardData.getData('text');
            if (!validateGiftOrderMessageInput(pastedData)) {
                e.preventDefault();
                return false;
            }

            var textarea = this;
            var start    = textarea.selectionStart;
            var end      = textarea.selectionEnd;

            var newText    = textarea.value.substring(0, start) + pastedData + textarea.value.substring(end);
            var maxLength  = Number($(this).attr('maxlength'));
            textarea.value = newText.substring(0, maxLength);

            // Move the cursor to the end of the inserted text;
            textarea.setSelectionRange(start + pastedData.length, start + pastedData.length);

            $(this).trigger('keyup');
        });

        // Updated the character counter for "Message" field;
        $(SELECTORS.giftOrderMessageField).on('keyup', (function () {
            var inputLength = $(this).val().length;

            $(SELECTORS.giftOrderMessageCounter).text(inputLength);
        }));

        // Saves gift data to session;
        $(GIFT_ORDER_FIELD_SELECTOR_LIST).on('input', (function () {
            var isGiftOrder         = $(SELECTORS.giftOrderIsGiftOrderField).is(':checked');
            var isCheckboxTriggered = $(this).hasClass('js-gift-order-checkbox');
            
            if (!isGiftOrder) {
                $(SELECTORS.giftOrderRecipientField).val('');
                $(SELECTORS.giftOrderSenderField).val('');
                $(SELECTORS.giftOrderMessageField).val('');
                $(SELECTORS.giftOrderMessageCounter).text(0);
            }

            var giftRecipient     = $(SELECTORS.giftOrderRecipientField).val();
            var giftSender        = $(SELECTORS.giftOrderSenderField).val();
            var giftMessage       = $(SELECTORS.giftOrderMessageField).val();
            var updateGiftDataUrl = $(SELECTORS.giftOrderContainer).data('update-url');
            var data = {
                isGiftOrder,
                giftRecipient,
                giftSender,
                giftMessage
            };
            
            $.ajax({
                url      : updateGiftDataUrl,
                type     : 'post',
                dataType : 'json',
                data     : data,
                success  : function () {
                    if (isCheckboxTriggered) {
                        location.reload();
                    }
                }
            });
        }));

        $('body').on('click', SELECTORS.giftOrderIsGiftOrderField, function () {
            var state = isGiftOrder() ? 
                CONSTANTS.STATES.EDITING :
                CONSTANTS.STATES.NO_GIFT_MESSAGE;

            setState(state);
        });

        $('.js-edit-gift').on('click', function () {
            setState(CONSTANTS.STATES.EDITING);
        });
    },
    methods: {
        fillGiftMessageSummary
    }
};
